/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from 'util/actions';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

const RAISE_ALERT = Symbol('ui/RAISE_ALERT');
const CANCEL_ALERT = Symbol('ui/CANCEL_ALERT');
const CANCEL_ALL_ALERTS = Symbol('ui/CANCEL_ALL_ALERTS');

export type AlertArea = string;
export type AlertName = string;

interface AlertPayload {
  [alertArea: string]: AlertName;
}

type RaiseAlertAction = Action<typeof RAISE_ALERT, AlertPayload>;
type CancelAlertAction = Action<typeof CANCEL_ALERT, AlertPayload>;
type CancelAlertsAction = Action<typeof CANCEL_ALL_ALERTS, void>;

export const raiseAlert = actionCreator<RaiseAlertAction>(RAISE_ALERT);
export const cancelAlert = actionCreator<CancelAlertAction>(CANCEL_ALERT);
export const cancelAllAlerts = actionCreator<CancelAlertsAction>(
  CANCEL_ALL_ALERTS,
);

export type AlertsState = AlertPayload;

const initialState: AlertsState = {};

export default createReducer(initialState, {
  [RAISE_ALERT](
    state,
    { payload: { alertArea, alertName } }: RaiseAlertAction,
  ) {
    const newState = {
      ...state,
      [alertArea]: alertName,
    };

    return newState;
  },

  [CANCEL_ALERT](state, { payload: { alertArea } }: CancelAlertAction) {
    const { [alertArea]: val, ...rest } = state;

    return rest;
  },

  [CANCEL_ALL_ALERTS]() {
    return initialState;
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/alerts.ts